// @ts-nocheck — TODO: tipizzare quando si tocca
// ====== Supabase Storage helpers per allegati documenti ======
// Bucket: 'documenti' (privato). Le RLS policy in improvements-schema.sql
// concedono upload/delete agli admin, read agli authenticated.

const DOC_BUCKET = 'documenti';

const storageApi = {
  // path: documenti/<cliente_id>/<uuid>.<ext>
  async uploadDocumento(clienteId, file) {
    if (!isAdmin()) throw new Error('Solo admin possono caricare allegati');
    const ext = (file.name.split('.').pop() || 'bin').toLowerCase();
    const safeBase = (file.name.split('.').slice(0, -1).join('.') || 'file')
      .replace(/[^a-zA-Z0-9_-]/g, '_')
      .slice(0, 40);
    const path = `${clienteId}/${safeBase}-${uid()}.${ext}`;
    const { error } = await sb.storage.from(DOC_BUCKET).upload(path, file, {
      cacheControl: '3600',
      upsert: false,
      contentType: file.type || 'application/octet-stream'
    });
    if (error) throw error;
    return path;
  },

  async signedUrl(path, ttlSec = 600) {
    const { data, error } = await sb.storage.from(DOC_BUCKET).createSignedUrl(path, ttlSec);
    if (error) throw error;
    return data.signedUrl;
  },

  async deleteFile(path) {
    if (!isAdmin()) throw new Error('Solo admin possono eliminare allegati');
    const { error } = await sb.storage.from(DOC_BUCKET).remove([path]);
    if (error) throw error;
  },

  async listForCliente(clienteId) {
    const { data, error } = await sb.storage.from(DOC_BUCKET).list(clienteId, { limit: 100 });
    if (error) throw error;
    return (data || []).map((f) => ({
      name: f.name,
      path: `${clienteId}/${f.name}`,
      size: f.metadata?.size || 0,
      updatedAt: f.updated_at
    }));
  }
};

// UI helper: aggancia un input file alla riga documento → upload + popola url
async function uploadDocumentoForRow(rowIdx, file, refreshCb) {
  const cliente = state.clients.find((c) => c.nome === globalThis.editingClientName);
  if (!cliente || !cliente._id) {
    toast('Salva prima il cliente per poter allegare file');
    return;
  }
  try {
    const path = await storageApi.uploadDocumento(cliente._id, file);
    if (Array.isArray(_documenti) && _documenti[rowIdx]) {
      _documenti[rowIdx].url = `storage://${DOC_BUCKET}/${path}`;
      _documenti[rowIdx].titolo = _documenti[rowIdx].titolo || file.name;
      _documenti[rowIdx].tipo = _documenti[rowIdx].tipo || file.type || 'file';
    }
    if (refreshCb) refreshCb();
    toast('File caricato. Salva il cliente per registrare il link.');
  } catch (e) {
    console.error(e);
    toast('Errore upload: ' + (e.message || e));
  }
}

// Quando in `documenti.url` c'è uno schema `storage://bucket/path`,
// recuperiamo la signed URL al click invece di aprire un link statico.
async function openStorageDocument(rawUrl) {
  if (!rawUrl) return;
  if (!rawUrl.startsWith('storage://')) {
    window.open(rawUrl, '_blank', 'noopener');
    return;
  }
  const path = rawUrl.replace(`storage://${DOC_BUCKET}/`, '');
  try {
    const url = await storageApi.signedUrl(path, 600);
    window.open(url, '_blank', 'noopener');
  } catch (e) {
    console.error(e);
    toast('Impossibile aprire: ' + (e.message || e));
  }
}

// Anteprima inline (modale): PDF in iframe, immagini in <img>, altri in download link.
async function previewStorageDocument(rawUrl, titolo) {
  if (!rawUrl) return;
  const modal = document.getElementById('modalDocPreview');
  if (!modal) {
    return openStorageDocument(rawUrl);
  }
  const titleEl = document.getElementById('docPreviewTitle');
  const bodyEl = document.getElementById('docPreviewBody');
  const downloadBtn = document.getElementById('docPreviewDownload');
  if (titleEl) titleEl.textContent = titolo || 'Anteprima documento';
  if (bodyEl)
    bodyEl.innerHTML =
      '<div class="muted" style="padding:24px;text-align:center;">Caricamento…</div>';
  modal.classList.remove('hidden');

  let signedUrl = rawUrl;
  if (rawUrl.startsWith('storage://')) {
    try {
      const path = rawUrl.replace(`storage://${DOC_BUCKET}/`, '');
      signedUrl = await storageApi.signedUrl(path, 600);
    } catch (e) {
      console.error(e);
      if (bodyEl)
        bodyEl.innerHTML = `<div class="muted" style="padding:24px;text-align:center;color:var(--danger);">Errore: ${escapeHtml(e.message || String(e))}</div>`;
      return;
    }
  }

  if (downloadBtn) {
    downloadBtn.href = signedUrl;
    downloadBtn.download = (titolo || 'documento').replace(/[^a-zA-Z0-9._-]/g, '_');
  }

  const ext = (signedUrl.split('?')[0].split('.').pop() || '').toLowerCase();
  const isImg = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg'].includes(ext);
  const isPdf = ext === 'pdf';
  if (!bodyEl) return;
  if (isImg) {
    bodyEl.innerHTML = `<img src="${escapeHtml(signedUrl)}" alt="${escapeHtml(titolo || 'Anteprima')}" style="max-width:100%;max-height:78vh;display:block;margin:0 auto;">`;
  } else if (isPdf) {
    bodyEl.innerHTML = `<iframe src="${escapeHtml(signedUrl)}" title="${escapeHtml(titolo || 'PDF')}" style="width:100%;height:78vh;border:none;background:var(--surface-alt);"></iframe>`;
  } else {
    bodyEl.innerHTML = `<div style="padding:32px;text-align:center;">
      <p class="muted" style="margin-bottom:16px;">Anteprima non supportata per questo formato (.${escapeHtml(ext)}).</p>
      <a class="btn btn-primary" href="${escapeHtml(signedUrl)}" target="_blank" rel="noopener">Apri / scarica</a>
    </div>`;
  }
}

function closeDocPreview() {
  document.getElementById('modalDocPreview')?.classList.add('hidden');
  const bodyEl = document.getElementById('docPreviewBody');
  if (bodyEl) bodyEl.innerHTML = '';
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-close-doc-preview]')
    .forEach((el) => el.addEventListener('click', closeDocPreview));
});

Object.assign(globalThis, {
  storageApi,
  uploadDocumentoForRow,
  openStorageDocument,
  previewStorageDocument,
  closeDocPreview
});
export {};
